/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef } from 'react';

import { ApolloCache, DefaultContext, OperationVariables, useMutation } from '@apollo/client';

import { IUseApolloMutationOptions } from './useApolloMutation.interfaces';

import { getApolloClient } from '../../utils';

const useApolloMutation = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
  TContext = DefaultContext,
  TCache extends ApolloCache<any> = ApolloCache<any>,
>({
  apiName,
  apolloLink,
  mutation,
  options,
  requestCredentials,
}: IUseApolloMutationOptions<TData, TVariables, TContext, TCache>) => {
  const client = useRef(
    getApolloClient({
      apiName,
      apolloLink,
      requestCredentials,
    }),
  ).current;

  return useMutation<TData, TVariables, TContext, TCache>(mutation, {
    ...options,
    client,
  });
};

export { useApolloMutation };
